import React from 'react';
import SearchBar from './SearchBar';
import NavbarElement from './NavbarElement';
import NavbarElementAccount from '../account/components/NavbarElementAccount';
import Loger from './Loger';

import {
  IconBxWorld,
  IconUser,
  IconBxsBellRing,
  IconNotebookEdit,
  IconProfile,
  IconFolderUserFill,
  IconUserSearchLine,
  IconGear,
  IconHelpCircle,
  IconBxPowerOff
} from '../icons/icons';
import '../gral-stylesheets/navbar.scss';
import ContourImages from './ContourImages';



class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrollTop: true,
      token: localStorage.getItem('token'),
      email: localStorage.getItem('email'),
      userImage: localStorage.getItem('userImage'),
      navbarElementClicked: this.props.navbarElementClicked,
      navbarElementOver: '',
      dropDownOn: '',
      language: 'English'
    };
  }
  componentDidMount(e) {
    window.addEventListener('scroll', this.navbarBackgroundHandle);
    this.navbarSeccionAnimationHandle();
    if (this.props.navbarType === 'about-us') {
      this.transform(100, 120);
    }
    else if (this.props.navbarType === 'blog') {
      this.transform(100, 90);
    }
  };
  componentWillUnmount() {
    window.removeEventListener('scroll', this.navbarBackgroundHandle);
  };
  navbarBackgroundHandle = () => {
    if (window.scrollY >= 5) {
      this.setState({
        scrollTop: false
      })
    }
    else {
      this.setState({
        scrollTop: true
      })
    };
  };

  transform = (position, broad) => {
    let indicator = document.getElementById('indicator');
    indicator.style.transform = `translateX(${position}px)`;
    indicator.style.width = `${broad}px`;
  };

  navbarSeccionAnimationHandle = (e) => {
    let sections = document.querySelectorAll('section');
    let activeSeccionIndex;

    const observer = new IntersectionObserver((entradas) => {
      entradas.forEach(entrada => {
        if (entrada.isIntersecting) {
          activeSeccionIndex = [...sections].indexOf(entrada.target);
          switch (this.props.navbarType) {
            case 'about-us':
              this.transform(100, 120);
              break;
            case 'blog':
              this.transform((100), 90);
              break;
            case 'authenticated':
              switch (activeSeccionIndex) {
                case 0:
                  this.transform(0, 100);
                  break;
                case 3:
                  this.transform(100, 160);
                  break;
                case 4:
                  this.transform((100 + 160), 90);
                  break;
                default:
                  this.transform(260, 0);
                  break;
              }
              break;
            case 'account':
              switch (activeSeccionIndex) {
                case 'job-request':
                  this.transform((100 + 100), 150);
                  break;
                case 'talent-request':
                  this.transform((100 + 100 + 150), 170);
                  break;
                case 'post-blog':
                  this.transform((100 + 100 + 150 + 170), 120);
                  break;
                case 'setting':
                  this.transform((100 + 100 + 150 + 170 + 120), 100);
                  break;
                case 'help':
                  this.transform((100 + 100 + 150 + 170 + 120 + 100), 80);
                  break;
                default:
                  this.transform(100, 100);
                  break;
              }
              this.props.navbarClickHandle(e);
              break;
            case 'unauthenticated':
              switch (activeSeccionIndex) {
                case 0:
                  this.transform(0, 100);
                  break;
                case 1:
                  this.transform(100, 110);
                  break;
                case 2:
                  this.transform((100 + 110), 100);
                  break;
                case 3:
                  this.transform((100 + 110 + 100), 120);
                  break;
                case 4:
                  this.transform((100 + 110 + 100 + 120), 160);
                  break;
                case 5:
                  this.transform((100 + 110 + 100 + 120 + 160), 90);
                  break;
                default:
                  this.transform(590, 0);
                  break;
              }
              break;
            default:
              this.transform(100, 100);
              break;
          }
        }
      });
    }, {
      rootMargin: '0px',
      threshold: 0.5
    });

    sections.forEach(section => observer.observe(section));

  }
  navbarAnimationHandle = (e) => {
    let navbarElement = e.currentTarget.dataset.value;

    switch (this.props.navbarType) {
      case 'about-us':
        this.transform(100, 120);
        break;
      case 'blog':
        this.transform(100, 90);
        break;
      case 'authenticated':
        switch (navbarElement) {
          case 'home':
            this.transform(0, 100);
            break;
          case 'testimonials':
            this.transform(100, 160);
            break;
          case 'blog':
            this.transform((100 + 160), 90);
            break;
          default:
            this.transform(260, 0);
            break;
        }
        break;
      case 'account':
        switch (navbarElement) {
          case 'job-request':
            this.transform((100 + 100), 150);
            break;
          case 'talent-request':
            this.transform((100 + 100 + 150), 170);
            break;
          case 'post-blog':
            this.transform((100 + 100 + 150 + 170), 120);
            break;
          case 'setting':
            this.transform((100 + 100 + 150 + 170 + 120), 100);
            break;
          case 'help':
            this.transform((100 + 100 + 150 + 170 + 120 + 100), 80);
            break;
          default:
            this.transform(100, 100);
            break;
        }
        this.props.navbarClickHandle(e);
        break;
      case 'unauthenticated':
        switch (navbarElement) {
          case 'talent':
            this.transform(100, 110);
            break;
          case 'job':
            this.transform((100 + 110), 100);
            break;
          case 'aboutUs':
            this.transform((100 + 110 + 100), 120);
            break;
          case 'testimonials':
            this.transform((100 + 110 + 100 + 120), 160);
            break;
          case 'blog':
            this.transform((100 + 110 + 100 + 120 + 160), 90);
            break;
          default:
            this.transform(0, 100);
            break;
        }
        break;
      default:
        this.transform(100, 100);
        break;
    }

    this.setState({
      navbarElementClicked: e.currentTarget.dataset.value
    });
  };
  dropdownOnHandle = (e) => {
    this.setState({
      navbarElementOver: e.currentTarget.dataset.value
    });
  };
  dropdownOffHandle = (e) => {
    this.setState({
      navbarElementOver: ''
    });
    let event = e.currentTarget.dataset.value;
    if (event === 'profile' || event === 'job-request' ||
      event === 'talent-request' || event === 'post-blog' ||
      event === 'setting' || event === 'help') {
      this.navbarAnimationHandle(e);
    }
  };
  languageHandle = (e) => {
    this.setState({
      language: e.currentTarget.dataset.value,
      navbarElementOver: ''
    });
  };

  render() {
    let scrollTop = this.state.scrollTop;
    let token = this.state.token;
    let searchBar = this.props.searchBar;
    let accountOn = this.props.accountOn;
    let aboutUs = this.props.aboutUs;
    let testimonials = this.props.testimonials;
    let blog = this.props.blog;
    let navbarElementClicked = this.state.navbarElementClicked;
    let navbarElementOver = this.state.navbarElementOver;

    let navbarElementAccount = [
      { item: 'Profile', id: 'profile', dataValue: 'profile' },
      { item: 'Job Request', id: 'job-request', dataValue: 'job-request' },
      { item: 'Talent Request', id: 'talent-request', dataValue: 'talent-request' },
      { item: 'Blog post', id: 'post-blog', dataValue: 'post-blog' },
      { item: 'Setting', id: 'setting', dataValue: 'setting' },
      { item: 'Help', id: 'help', dataValue: 'help' }
    ];

    return (
      <div
        id='navbar'
        className='navbar'
      >
        <div
          className={scrollTop
            ? 'navbar-container background-transparent'
            : 'navbar-container'
          }
          onScroll={this.navbarBackgroundHandle}
        >
          <div className='logo-container'>
            <h3>Dear</h3><h2>HR</h2>
          </div>
          <div
            className={searchBar ? token ? 'searchbar-container' : 'hidden-container' : 'hidden-container'}
          >
            <SearchBar />
          </div>
          <div className='navbar-right-container'>
            <nav
              id='navbar-id'
              className='navbar-right-indicated'
            >
              <ul>
                <NavbarElement
                  id='home-link'
                  title='Home'
                  href='#navbar'
                  dataValue='home'
                  navbarElementClicked={navbarElementClicked}
                  navbarAnimationHandle={this.navbarAnimationHandle}
                  navbarType={this.props.navbarType}
                  token={token}
                />
                {
                  this.props.navbarType === 'unauthenticated' ?
                    <>
                      <NavbarElement
                        id='talent-link'
                        title='Talents'
                        href='#talent'
                        dataValue='talent'
                        navbarElementClicked={navbarElementClicked}
                        navbarAnimationHandle={this.navbarAnimationHandle}
                      />
                      <NavbarElement
                        id='job-link'
                        title='Jobs'
                        href='#job'
                        dataValue='job'
                        navbarElementClicked={navbarElementClicked}
                        navbarAnimationHandle={this.navbarAnimationHandle}
                      />
                    </>
                    : ''
                }
                {
                  accountOn ?
                    navbarElementAccount.map((option, index) =>
                      <NavbarElementAccount
                        key={index}
                        data={option}
                        navbarClickHandle={this.props.navbarClickHandle}
                        navbarAnimationHandle={this.navbarAnimationHandle}
                        navbarElementClicked={this.props.navbarElementClicked}
                      />
                    )
                    : ''
                }
                {
                  aboutUs ?
                    <NavbarElement
                      id='aboutUs-link'
                      title='AboutUs'
                      href='#about-us'
                      dataValue='aboutUs'
                      navbarElementClicked={navbarElementClicked}
                      navbarAnimationHandle={this.navbarAnimationHandle}
                    />
                    : ''
                }
                {
                  testimonials ?
                    <NavbarElement
                      id='testimonials-link'
                      title='Testimonials'
                      href='#testimonials'
                      dataValue='testimonials'
                      navbarElementClicked={navbarElementClicked}
                      navbarAnimationHandle={this.navbarAnimationHandle}
                    />
                    : ''
                }
                {
                  blog ?
                    <NavbarElement
                      id='blog-link'
                      title='Blog'
                      href='#blog'
                      dataValue='blog'
                      navbarElementClicked={navbarElementClicked}
                      navbarAnimationHandle={this.navbarAnimationHandle}
                    />
                    : ''
                }
              </ul>
              <div
                className='navbar-indicator'
                id='indicator'
              />
            </nav>
            <nav className='navbar-right'>
              <ul>
                <NavbarElement
                  title={
                    <>
                      <i><IconBxWorld /></i>
                      <h2>{this.state.language}</h2>
                    </>
                  }
                  dataValue='languages'
                  dropdown={true}
                  dropdownType='selector'
                  dropdownActiveTitle='Languages'
                  dropdownOptions={[
                    { title: 'English', language: 'English - EN' },
                    { title: 'Español', language: 'Español - ES' },
                    { title: 'Português', language: 'Português - PT' },
                    { title: 'Français', language: 'Français - FR' },
                    { title: 'Deutsch', language: 'Deutsch - DE' }
                  ]}
                  navbarElementOver={navbarElementOver}
                  dropdownOnHandle={this.dropdownOnHandle}
                  dropdownOffHandle={this.dropdownOffHandle}
                  languageHandle={this.languageHandle}
                />
                {
                  token ?
                    <>
                      <NavbarElement
                        title={<i><IconBxsBellRing /></i>}
                        dataValue='notification'
                        dropdown={true}
                        dropdownType='notification'
                        dropdownActiveTitle='Notifications'
                        dropdownOptions={[
                          { notification: 'notification' },
                          { notification: 'notification' },
                          { notification: 'notification' },
                          { notification: 'notification' }
                        ]}
                        navbarElementOver={navbarElementOver}
                        dropdownOnHandle={this.dropdownOnHandle}
                        dropdownOffHandle={this.dropdownOffHandle}
                      />
                      <NavbarElement
                        title={<i><IconUser /></i>}
                        dataValue='user'
                        dropdown={true}
                        dropdownType='user'
                        dropdownActiveTitle={
                          <div className='dropdown-user-title'>
                            <div className='image-container'>
                              <ContourImages
                                image={this.state.userImage}
                              />
                            </div>
                            <div className='dropdown-user-name'>
                              <h3>{this.props.firstname}</h3>
                              <h5>{this.state.email ? this.state.email : ''}</h5>
                            </div>
                          </div>
                        }
                        dropdownOptions={[
                          { item: 'Profile', icon: <IconProfile />, dataValue: 'profile' },
                          { item: 'Job Request', icon: <IconFolderUserFill />, dataValue: 'job-request' },
                          { item: 'Talent Request', icon: <IconUserSearchLine />, dataValue: 'talent-request' },
                          { item: 'Blog post', icon: <IconNotebookEdit />, dataValue: 'post-blog' },
                          { item: 'Setting', icon: <IconGear />, dataValue: 'setting' },
                          { item: 'Help', icon: <IconHelpCircle />, dataValue: 'help' },
                          { item: 'Logout', icon: <IconBxPowerOff />, dataValue: '' }
                        ]}
                        navbarElementOver={navbarElementOver}
                        dropdownOnHandle={this.dropdownOnHandle}
                        dropdownOffHandle={this.dropdownOffHandle}
                        navbarElementClicked={this.props.navbarElementClicked}
                        navbarClickHandle={this.props.navbarClickHandle}
                      />
                    </>
                    :
                    <Loger
                      loginOpenHandle={this.props.loginOpenHandle}
                      joinOpenHandle={this.props.joinOpenHandle}
                    />
                }
              </ul>
            </nav>
          </div>
        </div>
      </div>
    )
  }
}

export default Navbar;